// extracted by mini-css-extract-plugin
export default {"container":"S02_container__Emm7G","limiter":"S02_limiter__cB5-1","videoWrapper":"S02_videoWrapper__wco8K","video":"S02_video__eTTOC"};